/* eslint-disable */
// @ts-nocheck
export function initCm2Engine() {
  'use strict'
  var PERSONAL = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'aol.com',
    'icloud.com',
    'mail.com',
    'protonmail.com',
    'yandex.com',
    'zoho.com',
    'gmx.com',
    'live.com',
    'me.com',
    'msn.com',
    'qq.com',
    '163.com',
    '126.com',
  ]
  var BOX =
    '<svg viewBox="0 0 16 16" fill="none"><path d="M8 1.5L13.5 4.5V11.5L8 14.5L2.5 11.5V4.5L8 1.5Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>'
  var CHEV = '›'
  var MAIL =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10" /><path d="M3 7l9 6l9 -6" /></svg>'
  var SEARCH =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>'
  var SPARK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2m0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2m-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6"/></svg>'
  var PIN =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-6-5.7-6-10a6 6 0 0 1 12 0c0 4.3-6 10-6 10z"/><circle cx="12" cy="11" r="2"/></svg>'
  // ---- canned product-breakdown templates: names only (mass/cost stay gated) ----
  var TEMPLATES = {
    battery: {
      kw: [
        'batt',
        'cell',
        'nmc',
        'lfp',
        'lithium',
        'anode',
        'cathode',
        '18650',
        'pack',
      ],
      comps: [
        'Cathode (NMC811)',
        'Anode (graphite)',
        'Electrolyte',
        'Separator film',
        'Current collector — Cu',
        'Current collector — Al',
        'Cell can / housing',
        'Terminal assembly',
        'Tab welds',
        'Safety vent',
        'Insulation tape',
        'Pack labeling',
      ],
    },
    pcb: {
      kw: ['pcb', 'pcba', 'circuit', 'board', 'electronic', 'smt'],
      comps: [
        'Processor / main IC',
        'Memory module',
        'Power management IC',
        'Bare PCB substrate',
        'Passive components (R/C/L)',
        'Crystal / oscillator',
        'Connectors & headers',
        'Shielding cans',
        'Solder paste & SMT',
        'Conformal coating',
        'Functional test',
        'Firmware flashing',
      ],
    },
    molded: {
      kw: [
        'plastic',
        'mold',
        'molded',
        'injection',
        'housing',
        'enclosure',
        'casing',
        'bracket',
      ],
      comps: [
        'Polymer resin (ABS)',
        'Colorant masterbatch',
        'Mold-release additives',
        'Machine cycle time',
        'Tooling amortization',
        'Metal insert / hardware',
        'Snap-fit features',
        'Surface texturing',
        'Deflashing & trim',
        'Ultrasonic welding',
        'Finishing & QA',
        'Packaging',
      ],
    },
    cable: {
      kw: ['cable', 'wire', 'harness', 'connector', 'loom'],
      comps: [
        'Copper conductor',
        'Tinning / plating',
        'Insulation jacket',
        'Shielding braid',
        'Drain wire',
        'Terminals / contacts',
        'Connector housings',
        'Backshell / strain relief',
        'Heat-shrink tubing',
        'Overmolding',
        'Assembly labor',
        'Continuity inspection',
      ],
    },
    generic: {
      kw: [],
      comps: [
        'Primary structure',
        'Secondary components',
        'Sub-assembly A',
        'Sub-assembly B',
        'Fasteners & hardware',
        'Seals & gaskets',
        'Surface finish / coating',
        'Adhesives & bonding',
        'Sub-assembly labor',
        'Functional test',
        'Inspection & QA',
        'Packaging',
      ],
    },
  }
  var COUNTRY_MULT = [
    ['china', 0.82],
    ['vietnam', 0.85],
    ['india', 0.8],
    ['mexico', 0.9],
    ['taiwan', 0.92],
    ['thailand', 0.86],
    ['malaysia', 0.88],
    ['indonesia', 0.84],
    ['korea', 1.0],
    ['japan', 1.12],
    ['germany', 1.2],
    ['switzerland', 1.3],
    ['united states', 1.18],
    ['united kingdom', 1.15],
    ['france', 1.16],
    ['italy', 1.1],
    ['netherlands', 1.15],
    ['ireland', 1.14],
    ['singapore', 1.08],
    ['canada', 1.12],
    ['brazil', 0.98],
    ['poland', 0.95],
  ]
  function pickTemplate(name) {
    var n = (name || '').toLowerCase()
    for (var k in TEMPLATES) {
      if (k === 'generic') continue
      if (
        TEMPLATES[k].kw.some(function (w) {
          return n.indexOf(w) >= 0
        })
      )
        return TEMPLATES[k]
    }
    return TEMPLATES.generic
  }
  function countryMult(c) {
    c = (c || '').toLowerCase()
    for (var i = 0; i < COUNTRY_MULT.length; i++) {
      if (c.indexOf(COUNTRY_MULT[i][0]) >= 0) return COUNTRY_MULT[i][1]
    }
    return 1.0
  }
  function fmt(n) {
    return (
      '$' +
      n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    )
  }
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
  }

  // ---- Beat A: resolve a typed product to a canonical name + category (swap for real lookup later) ----
  function titleCase(s) {
    return String(s || '')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, function (m) {
        return m.toUpperCase()
      })
  }
  var CANON = [
    { kw: ['airpod'], name: 'AirPods Pro (2nd gen)', cat: 'Consumer audio' },
    { kw: ['iphone'], name: 'iPhone 15 Pro', cat: 'Consumer electronics' },
    {
      kw: ['macbook', 'laptop'],
      name: 'MacBook Pro 14″',
      cat: 'Consumer electronics',
    },
    {
      kw: ['ev batt', 'ev pack', 'tesla', 'traction batt'],
      name: 'EV traction battery module',
      cat: 'Battery / energy storage',
    },
    { kw: ['drone', 'quadcopter'], name: 'Quadcopter drone', cat: 'Robotics' },
  ]
  var CATBY = {
    battery: 'Battery / energy storage',
    pcb: 'Electronics / PCBA',
    molded: 'Molded component',
    cable: 'Cable / harness',
    generic: '',
  }
  function templateCat(name) {
    var n = (name || '').toLowerCase()
    for (var k in TEMPLATES) {
      if (k === 'generic') continue
      if (
        TEMPLATES[k].kw.some(function (w) {
          return n.indexOf(w) >= 0
        })
      )
        return CATBY[k]
    }
    return CATBY.generic
  }
  function identify(name) {
    var n = (name || '').toLowerCase()
    for (var i = 0; i < CANON.length; i++) {
      if (
        CANON[i].kw.some(function (w) {
          return n.indexOf(w) >= 0
        })
      )
        return { name: CANON[i].name, cat: CANON[i].cat }
    }
    return { name: titleCase(name), cat: templateCat(name) }
  }

  var browser,
    tabsEl,
    panelsEl,
    urlEl,
    tabs = [],
    activeId = null,
    activeSampleKey = 'nmc',
    tabSeq = 0
  var heroFormStep, heroCta, heroCtaTxt, heroCard
  var SAMPLE_URLS = {
    nmc: 'nmc-battery',
    citric: 'citric-acid',
    soc: 'smart-home-soc',
  }
  var SAMPLE_LABELS = {
    nmc: 'NMC Battery Cell',
    citric: 'Citric Acid',
    soc: 'Smart Home SoC',
  }
  var PHASE_MSG = {
    search: 'Understanding your product…',
    breakdown: 'Breaking down to components…',
    manufacturing: 'Predicting manufacturing steps…',
    sourcing: 'Predicting sourcing…',
    costing: 'Layering cost intelligence…',
    ready: 'Your cost model is ready',
  }

  function slug(s) {
    return (
      String(s || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 32) || 'product'
    )
  }
  function tabLabel(name) {
    var n = identify(name).name
    return n.length > 22 ? n.slice(0, 20) + '…' : n
  }
  function isAlive(ctx) {
    return !!(ctx && ctx.alive && ctx.panel && ctx.panel.isConnected)
  }
  function activeCtx() {
    if (!activeId) return null
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].id === activeId) return tabs[i]
    }
    return null
  }
  // the left hero form acts as the email gate whenever the active tab is a live product model (building or ready, until submitted)
  function gateCtx() {
    var c = activeCtx()
    return c && isAlive(c) ? c : null
  }

  function initHeroPanel() {
    if (heroFormStep) return
    var form = document.getElementById('wf-form-Cost-model-form_step-1')
    var nameBlock = document.getElementById('mi-form-name-and-origin')
    var buildBtn = document.getElementById('build-cost-model')
    heroCard = document.querySelector(
      '.hero-edgy .mi-hero_content.solution.cost_model_landing',
    )
    if (!form || !nameBlock || !buildBtn || !heroCard) return
    heroFormStep = document.createElement('div')
    heroFormStep.id = 'cm2-hero-form-step'
    heroFormStep.className = 'cm2-hero-form-step'
    form.insertBefore(heroFormStep, nameBlock)
    heroFormStep.appendChild(nameBlock)
    heroFormStep.appendChild(buildBtn)
    heroCta = document.createElement('div')
    heroCta.id = 'cm2-hero-cta'
    heroCta.className = 'cm2-hero-cta'
    heroCta.hidden = true
    heroCta.innerHTML =
      '<div class="cm2-hero-cta-live">' +
      '<div class="cm2-hero-cta-status"><span class="cm2-hero-cta-dot"></span><span class="cm2-hero-cta-txt">Building your cost model…</span></div>' +
      '<p class="cm2-hero-cta-sub">Get the full breakdown delivered to your inbox, or book time with our team.</p>' +
      '<div class="cm2-hero-cta-form"><input type="email" id="cm2-hero-email" placeholder="you@company.com" autocomplete="email"/>' +
      '<div class="cm2-hero-cta-err">Please enter a valid work email.</div>' +
      '<button type="button" class="mi-button primary-right-icon primary-no-icon w-inline-block" id="cm2-hero-email-btn"><div class="mi-button16 white-text">Email me the model</div></button></div>' +
      '</div>' +
      '<div class="cm2-hero-cta-sent" hidden>' +
      '<div class="cm2-hero-cta-status"><span class="cm2-hero-cta-dot done"></span><span class="cm2-hero-cta-txt-sent">Your cost model is on the way</span></div>' +
      '<p class="cm2-hero-cta-sub cm2-hero-sent-sub"></p>' +
      '</div>' +
      '<div class="cm2-hero-cta-actions"><a href="https://calendly.com/harris-muir/muir-demo-request" target="_blank" rel="noopener" class="mi-button secondary-medium-right-icon w-inline-block"><div class="mi-button16">Book a demo</div><div class="mi-button_icon-container"><img loading="lazy" src="assets/6941e9534f1121c2cce1b150_arrow-right%20(1).svg" alt="" class="mi-button_icon"/></div></a></div>'
    heroFormStep.parentNode.insertBefore(heroCta, heroFormStep.nextSibling)
    heroCtaTxt = heroCta.querySelector('.cm2-hero-cta-live .cm2-hero-cta-txt')
    var emailIn = heroCta.querySelector('#cm2-hero-email')
    var emailBtn = heroCta.querySelector('#cm2-hero-email-btn')
    var emailErr = heroCta.querySelector('.cm2-hero-cta-err')
    function submitHeroEmail() {
      var v = (emailIn.value || '').trim(),
        lv = v.toLowerCase(),
        at = lv.indexOf('@')
      var ok =
        at > 0 &&
        lv.indexOf('.', at) > at &&
        PERSONAL.indexOf(lv.slice(at + 1)) < 0
      if (!ok) {
        emailIn.classList.add('err')
        emailErr.classList.add('on')
        emailIn.focus()
        return
      }
      emailIn.classList.remove('err')
      emailErr.classList.remove('on')
      var ref = gateCtx()
      if (ref) {
        ref.submitted = true
        ref.email = v
      } // keep the cost blurred; we just confirm it's on the way
      if (window.MuirLead)
        window.MuirLead({
          email: v,
          product:
            (document.getElementById('hero-dd-product') || {}).value || '',
          country:
            (document.getElementById('hero-dd-country') || {}).value || '',
          source: 'hero-cta',
        })
      updateHeroPanel()
    }
    emailBtn.addEventListener('click', submitHeroEmail)
    emailIn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submitHeroEmail()
    })
    emailIn.addEventListener('input', function () {
      emailIn.classList.remove('err')
      emailErr.classList.remove('on')
    })
  }

  function updateHeroPanel() {
    initHeroPanel()
    if (!heroFormStep || !heroCta) return
    var ref = gateCtx()
    var showGate = !!ref
    heroFormStep.hidden = showGate // hide the product form while a model is live
    heroCta.hidden = !showGate // …and show the email gate in its place
    if (heroCard) heroCard.classList.toggle('cm2-modeling', showGate)
    if (!showGate) return
    var live = heroCta.querySelector('.cm2-hero-cta-live')
    var sent = heroCta.querySelector('.cm2-hero-cta-sent')
    var ready = ref.phase === 'ready'
    heroCta.classList.toggle('cm2-ready', ready && !ref.submitted)
    if (ref.submitted) {
      if (live) live.hidden = true
      if (sent) {
        sent.hidden = false
        var ss = sent.querySelector('.cm2-hero-sent-sub')
        if (ss)
          ss.textContent =
            'We’ll email the full cost & mass breakdown to ' + ref.email + '.'
      }
    } else {
      if (sent) sent.hidden = true
      if (live) {
        live.hidden = false
        var txt = live.querySelector('.cm2-hero-cta-txt')
        if (txt) txt.textContent = PHASE_MSG[ref.phase] || PHASE_MSG.search
      }
    }
  }

  function initBrowser() {
    if (browser) return
    browser = document.getElementById('cm2-inline-browser')
    tabsEl = document.getElementById('cm2-tabs')
    panelsEl = document.getElementById('cm2-panels')
    urlEl = browser && browser.querySelector('.cm2-url-txt')
    var addBtn = document.getElementById('cm2-tab-add')
    if (addBtn) addBtn.addEventListener('click', scrollToForm)
    var heroTabAdd = document.getElementById('hero-tab-add')
    if (heroTabAdd && !heroTabAdd.dataset.bound) {
      heroTabAdd.dataset.bound = '1'
      heroTabAdd.addEventListener('click', function (e) {
        e.stopPropagation()
        var pop = document.getElementById('hero-tab-add-pop')
        if (pop && !pop.hidden) closeHeroTabAddPop()
        else openHeroTabAddPop()
      })
    }
    var heroTabPop = document.getElementById('hero-tab-add-pop')
    if (heroTabPop && !heroTabPop.dataset.bound) {
      heroTabPop.dataset.bound = '1'
      heroTabPop.querySelectorAll('.hero-dd-opt').forEach(function (opt) {
        opt.addEventListener('mousedown', function (e) {
          e.preventDefault()
        })
        opt.addEventListener('click', function (e) {
          e.stopPropagation()
          if (opt.hasAttribute('data-custom')) {
            closeHeroTabAddPop()
            if (window.openHeroConversionModal) window.openHeroConversionModal()
            return
          }
          var key = opt.getAttribute('data-key')
          if (key) heroGenerateFromSampleKey(key)
        })
      })
    }
    if (tabsEl) tabsEl.addEventListener('click', onTabClick)
    Array.prototype.forEach.call(
      tabsEl.querySelectorAll('.mi-window__tab[data-tab]'),
      function (t) {
        t.setAttribute('role', 'tab')
        t.setAttribute('tabindex', '0')
      },
    )
  }

  function scrollToForm() {
    var el = document.getElementById('product-name')
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      el.focus()
    }
  }

  function setSampleVisible(show) {
    if (!panelsEl) return
    Array.prototype.forEach.call(panelsEl.children, function (el) {
      if (!el.classList.contains('cm2-tab-panel'))
        el.style.display = show ? '' : 'none'
    })
  }

  function setTabPhase(ctx, phase) {
    if (!ctx || !ctx.tabBtn) return
    ctx.phase = phase || 'search'
    if (phase) ctx.tabBtn.setAttribute('data-phase', phase)
    else ctx.tabBtn.removeAttribute('data-phase')
    updateHeroPanel()
    if (window.updateHeroBuildingStatus) window.updateHeroBuildingStatus(phase)
  }

  function switchSampleTab(key, activeTab) {
    activeId = null
    activeSampleKey = key
    Array.prototype.forEach.call(
      tabsEl.querySelectorAll('.mi-window__tab'),
      function (t) {
        var on = activeTab
          ? t === activeTab
          : (t.getAttribute('data-sample-key') ||
              t.getAttribute('data-tab')) === key
        t.classList.toggle('is-active', on)
        t.setAttribute('aria-selected', on ? 'true' : 'false')
      },
    )
    tabs.forEach(function (t) {
      t.panel.classList.remove('is-active')
      t.panel.hidden = true
    })
    setSampleVisible(true)
    if (window.heroShowSample && window.heroPanelsReady)
      window.heroShowSample(key)
    if (urlEl) urlEl.textContent = 'muir.ai / ' + (SAMPLE_URLS[key] || key)
    updateHeroPanel() // sample tab → no live model → show the product form
  }

  function switchDynamicTab(id) {
    activeSampleKey = null
    activeId = id
    Array.prototype.forEach.call(
      tabsEl.querySelectorAll('.mi-window__tab[data-tab]'),
      function (t) {
        t.classList.remove('is-active')
        t.setAttribute('aria-selected', 'false')
      },
    )
    setSampleVisible(false)
    tabs.forEach(function (t) {
      var on = t.id === id
      t.tabBtn.classList.toggle('is-active', on)
      t.tabBtn.setAttribute('aria-selected', on ? 'true' : 'false')
      t.panel.classList.toggle('is-active', on)
      t.panel.hidden = !on
    })
    var cur = null
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].id === id) {
        cur = tabs[i]
        break
      }
    }
    if (cur && urlEl) urlEl.textContent = 'muir.ai / ' + slug(cur.rawName)
    if (browser && !window.cm2NoScroll)
      browser.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    updateHeroPanel() // reflect this tab's gate state (building / ready / sent)
  }

  // Tabs + the "+" live in an inner scroll strip so the strip can scroll
  // horizontally on mobile while the CTA sits on its own row in #cm2-tabs.
  function tabStripEl() {
    return document.getElementById('cm2-tabs-strip') || tabsEl
  }

  function ensureHeroTabAddWrap() {
    initBrowser()
    var wrap = document.getElementById('hero-tab-add-wrap')
    var strip = tabStripEl()
    if (!wrap || !strip) return
    if (wrap.parentNode !== strip) strip.appendChild(wrap)
    ensureHeroTabCtaWrap()
  }

  function ensureHeroTabCtaWrap() {
    var wrap = document.getElementById('hero-tab-cta-wrap')
    if (!wrap || !tabsEl) return
    if (wrap.parentNode !== tabsEl) tabsEl.appendChild(wrap)
  }

  function closeHeroTabAddPop() {
    var pop = document.getElementById('hero-tab-add-pop')
    var btn = document.getElementById('hero-tab-add')
    var wrap = document.getElementById('hero-tab-add-wrap')
    if (pop) pop.hidden = true
    if (btn) btn.setAttribute('aria-expanded', 'false')
    if (wrap) wrap.classList.remove('open')
  }

  function openHeroTabAddPop() {
    ensureHeroTabAddWrap()
    var pop = document.getElementById('hero-tab-add-pop')
    var btn = document.getElementById('hero-tab-add')
    var wrap = document.getElementById('hero-tab-add-wrap')
    if (!pop || !btn) return
    pop.hidden = false
    btn.setAttribute('aria-expanded', 'true')
    if (wrap) wrap.classList.add('open')
  }

  function heroGenerateFromSampleKey(key) {
    var map = {
      nmc: { product: 'NMC Battery Cell', country: 'China' },
      citric: { product: 'Citric Acid', country: 'Germany' },
      soc: { product: 'Smart Home SoC', country: 'Taiwan' },
    }
    var item = map[key]
    if (!item) return
    var pin = document.getElementById('hero-dd-product')
    var cin = document.getElementById('hero-dd-country')
    var pl = document.getElementById('hero-dd-product-label')
    var cl = document.getElementById('hero-dd-country-label')
    if (pin) pin.value = item.product
    if (cin) cin.value = item.country
    if (pl) pl.textContent = item.product + ' '
    if (cl) cl.textContent = item.country
    closeHeroTabAddPop()
    if (window.heroStartGenerate) window.heroStartGenerate()
  }
  window.heroGenerateFromSampleKey = heroGenerateFromSampleKey
  window.closeHeroTabAddPop = closeHeroTabAddPop

  function resetHeroToIdle() {
    var hero = document.getElementById('hero')
    if (hero) {
      hero.setAttribute('data-hero-phase', 'idle')
      hero.removeAttribute('data-hero-browser')
    }
    if (tabsEl) {
      tabsEl
        .querySelectorAll(
          '.mi-window__tab[data-sample-key], .mi-window__tab[data-tab-id]',
        )
        .forEach(function (t) {
          t.remove()
        })
    }
    tabs.length = 0
    activeId = null
    activeSampleKey = null
    closeHeroTabAddPop()
    var addWrap = document.getElementById('hero-tab-add-wrap')
    if (addWrap) addWrap.hidden = true
    if (window.hideHeroTabCta) window.hideHeroTabCta(true)
    if (tabsEl) tabsEl.hidden = true
    setSampleVisible(true)
    if (window.heroShowIdle) window.heroShowIdle()
    else if (window.heroShowSample) window.heroShowSample('idle')
    updateHeroPanel()
    var genBtn = document.getElementById('hero-generate-btn')
    if (genBtn) {
      genBtn.disabled = false
      genBtn.textContent = 'Generate Cost Model'
    }
  }

  function closeSampleTab(key) {
    if (!tabsEl || !key) return
    var tab = tabsEl.querySelector('.mi-window__tab[data-tab="' + key + '"]')
    if (!tab) return
    tab.remove()
    var rest = tabsEl.querySelectorAll(
      '.mi-window__tab[data-sample-key], .mi-window__tab[data-tab]',
    )
    if (!rest.length) resetHeroToIdle()
    else switchSampleTab(rest[rest.length - 1].getAttribute('data-tab'))
  }

  function onTabClick(e) {
    if (e.target.closest && e.target.closest('.hero-tab-add-wrap')) return
    if (e.target.closest && e.target.closest('.hero-tab-cta-wrap')) return
    if (e.target.closest && e.target.closest('.cm2-tab-add')) return
    var tab = e.target.closest && e.target.closest('.mi-window__tab')
    if (!tab) return
    var sampleKey = tab.getAttribute('data-sample-key')
    var dynId = tab.getAttribute('data-tab-id')
    if (dynId && !sampleKey) switchDynamicTab(dynId)
    else if (sampleKey) switchSampleTab(sampleKey, tab)
    else {
      var legacyKey = tab.getAttribute('data-tab')
      if (legacyKey) switchSampleTab(legacyKey, tab)
    }
  }

  function closeTab(id) {
    var i = -1
    for (var j = 0; j < tabs.length; j++) {
      if (tabs[j].id === id) {
        i = j
        break
      }
    }
    if (i < 0) return
    var t = tabs[i]
    t.alive = false
    t.tabBtn.remove()
    t.panel.remove()
    tabs.splice(i, 1)
    if (activeId === id) {
      if (tabs.length) switchDynamicTab(tabs[Math.max(0, i - 1)].id)
      else switchSampleTab(activeSampleKey || 'nmc')
    }
    updateHeroPanel()
  }

  function finalizeHeroGeneratedTab(ctx, sampleKey) {
    initBrowser()
    if (!ctx || !ctx.tabBtn || !tabsEl) return
    if (ctx.panel) {
      ctx.panel.remove()
      ctx.panel = null
    }
    var i = -1
    for (var j = 0; j < tabs.length; j++) {
      if (tabs[j].id === ctx.id) {
        i = j
        break
      }
    }
    if (i >= 0) tabs.splice(i, 1)
    activeId = null
    activeSampleKey = sampleKey
    ctx.tabBtn.classList.remove('cm2-user-tab')
    ctx.tabBtn.removeAttribute('data-tab-id')
    ctx.tabBtn.setAttribute('data-tab', ctx.id)
    ctx.tabBtn.setAttribute('data-sample-key', sampleKey)
    ctx.tabBtn.classList.add('is-active')
    ctx.tabBtn.setAttribute('aria-selected', 'true')
    ctx.tabBtn.setAttribute('data-phase', 'ready')
    var lbl = ctx.tabBtn.querySelector('.cm2-tab-label')
    if (lbl) lbl.textContent = SAMPLE_LABELS[sampleKey] || lbl.textContent
    var spin = ctx.tabBtn.querySelector('.cm2-tab-spin')
    if (spin) spin.remove()
    var x = ctx.tabBtn.querySelector('.cm2-tab-x')
    if (x) x.remove()
    setSampleVisible(true)
    if (urlEl)
      urlEl.textContent = 'muir.ai / ' + (SAMPLE_URLS[sampleKey] || sampleKey)
    updateHeroPanel()
    ensureHeroTabAddWrap()
    var addWrap = document.getElementById('hero-tab-add-wrap')
    if (addWrap) addWrap.hidden = false
    if (window.scheduleHeroTabCta) window.scheduleHeroTabCta()
  }
  window.finalizeHeroGeneratedTab = finalizeHeroGeneratedTab

  function createTab(name, country) {
    initBrowser()
    tabSeq++
    var id = 'tab-' + tabSeq
    var tabBtn = document.createElement('div')
    tabBtn.className = 'mi-window__tab cm2-user-tab'
    tabBtn.setAttribute('data-tab-id', id)
    tabBtn.setAttribute('role', 'tab')
    tabBtn.setAttribute('tabindex', '0')
    tabBtn.setAttribute('data-phase', 'search')
    tabBtn.innerHTML =
      '<span class="cm2-tab-label">' +
      escapeHtml(tabLabel(name)) +
      '</span><span class="cm2-tab-spin" aria-hidden="true"></span>'
    var panel = document.createElement('div')
    panel.className = 'cm2-tab-panel'
    panel.setAttribute('data-tab-id', id)
    panel.hidden = true
    panel.innerHTML =
      '<div class="cm2-modal searching"><div class="cm2-body"></div></div>'
    var strip = tabStripEl()
    var addWrap = strip.querySelector('.hero-tab-add-wrap')
    strip.insertBefore(tabBtn, addWrap || null)
    panelsEl.appendChild(panel)
    var ctx = {
      id: id,
      rawName: name,
      country: country || '',
      phase: 'search',
      tabBtn: tabBtn,
      panel: panel,
      modal: panel.querySelector('.cm2-modal'),
      body: panel.querySelector('.cm2-body'),
      alive: true,
    }
    tabs.push(ctx)
    switchDynamicTab(id)
    updateHeroPanel()
    runSession(ctx, name, country)
    return ctx
  }

  function toast(msg) {
    var t = document.createElement('div')
    t.className = 'cm2-toast'
    t.textContent = msg
    document.body.appendChild(t)
    requestAnimationFrame(function () {
      t.classList.add('on')
    })
    setTimeout(function () {
      t.classList.remove('on')
      setTimeout(function () {
        t.remove()
      }, 300)
    }, 2200)
  }

  // mass/cost are gated (no real data): render a blurred skeleton placeholder.
  function skelCell() {
    return '<div class="cm2-num cm2-skelcell"><span class="cm2-skel sk-num"></span><span class="cm2-skel sk-bar"></span></div>'
  }
  // mass column cell — a shimmer skeleton (gated; no real value shown yet).
  function massCell() {
    return '<div class="cm2-mass"><span class="cm2-skel sk-num"></span></div>'
  }
  // sourcing column cell — only the product row carries the country tag; empty elsewhere (not searched yet).
  function srcCell(inner) {
    return '<div class="cm2-src">' + (inner || '') + '</div>'
  }
  // component row — name + mass both stay shimmer skeletons (gated; no real data shown).
  function childRow(nm, isLast) {
    return (
      '<div class="cm2-row" data-nm="' +
      escapeHtml(nm) +
      '"><div class="nm"><span class="cm2-guide ' +
      (isLast ? 'elbow' : 'tee') +
      ' show"></span><span class="cm2-ic">' +
      BOX +
      '</span><span class="cm2-lbl"><span class="cm2-skel sk-name"></span></span></div>' +
      massCell() +
      srcCell() +
      '</div>'
    )
  }
  // tier-3 sub-row (one indent deeper): a pipe guide passes through the tier-2 level.
  function tier3Row(isLast) {
    return (
      '<div class="cm2-row cm2-sub"><div class="nm"><span class="cm2-guide pipe show"></span><span class="cm2-guide ' +
      (isLast ? 'elbow' : 'tee') +
      ' show"></span><span class="cm2-ic">' +
      BOX +
      '</span><span class="cm2-lbl"><span class="cm2-skel sk-name"></span></span></div>' +
      massCell() +
      srcCell() +
      '</div>'
    )
  }
  function subCount(seed) {
    return 3 + (seed % 2)
  } // 3–4 sub-rows per component
  // swap a row's name skeleton for the resolved name, fading in.
  function resolveName(row) {
    var nm = row.getAttribute('data-nm')
    if (!nm) return
    var lbl = row.querySelector('.cm2-lbl')
    lbl.innerHTML = '<span class="cm2-name-in">' + escapeHtml(nm) + '</span>'
  }

  function runSession(ctx, name, country) {
    var t = pickTemplate(name)
    var comps = t.comps.slice()

    var id = identify(name)
    var modal = ctx.modal
    var body = ctx.body
    var panel = ctx.panel
    var line = null,
      lineTxt = null
    function setStatus(txt, done) {
      if (!line || !lineTxt) return
      lineTxt.textContent = txt
      line.classList.toggle('done', !!done)
    }

    // ---- tuning knobs ----
    var SCAN_DUR = 950,
      SCAN_CYCLES = 1,
      HOLD_MS = 220 // Beat A: shimmer cycle / # of cycles / hold after shimmer
    var CASCADE_STEP = 45,
      PHASE_GAP = 120,
      CASCADE_HOLD = 350,
      CASCADE_GAP = 200 // Beat B: per-row stagger / pause before deeper level / hold when full / gap before repeat

    // ----- Beat A · search / identify: small modal, no breakdown yet -----
    body.className = 'cm2-body'
    var locA = country
      ? '<span class="cm2-loc cm2-search-loc">' +
        PIN +
        '<span>' +
        escapeHtml(country) +
        '</span></span>'
      : ''
    body.innerHTML =
      '<div class="cm2-search"><div class="cm2-search-orb">' +
      SEARCH +
      '</div><div class="cm2-search-name scan">' +
      escapeHtml(id.name) +
      '</div>' +
      locA +
      '<div class="cm2-search-sub">' +
      SPARK +
      '<span>Understanding and enriching product information</span></div></div>'
    modal.classList.add('searching')
    setStatus('Searching product data…', false)
    setTabPhase(ctx, 'search')

    // run the shimmer for exactly SCAN_CYCLES, then (after a short hold) enlarge + move
    var scanName = body.querySelector('.cm2-search-name')
    var scanned = false
    function afterScan() {
      if (scanned) return
      scanned = true
      if (scanName) scanName.classList.remove('scan')
      setStatus('Identified product.', false)
      setTimeout(beginBuild, HOLD_MS)
    }
    if (scanName)
      scanName.addEventListener('animationend', afterScan, { once: true })
    setTimeout(afterScan, SCAN_DUR * SCAN_CYCLES + 150) // fallback if animationend doesn't fire

    // ----- Build phases — expand the modal, then draw the breakdown -----
    function beginBuild() {
      // ---- capture the centered search name's text box (FLIP "first") ----
      var nameEl = body.querySelector('.cm2-search-name')
      var firstRect = null
      if (nameEl) {
        var fr = document.createRange()
        fr.selectNodeContents(nameEl)
        firstRect = fr.getBoundingClientRect()
      }

      // float a clone of the name that will glide into row 1 once the modal expands
      var fly = null
      if (firstRect && firstRect.width) {
        fly = document.createElement('div')
        fly.className = 'cm2-fly'
        fly.textContent = id.name
        fly.style.left = firstRect.left + 'px'
        fly.style.top = firstRect.top + 'px'
        document.body.appendChild(fly)
      }

      // Option A — the country pill no longer flies in alongside the name. Only the product name glides
      // into row 1 here; the pill appears later, during the Sourcing phase, with its own small animation.
      // Keep the vars (null) so the shared FLIP logic below stays a no-op for sourcing.
      var locFirst = null,
        locFly = null

      // cap tier-2 rows so the tree (incl. the three expanded groups) fits the modal without scrolling.
      var ROW_H = 38,
        SUB = 3,
        PICKS = 2
      var maxComp = Math.max(
        8,
        Math.floor((window.innerHeight * 0.9 - 190) / ROW_H),
      )
      var tier2Max = Math.max(4, maxComp - PICKS * SUB)
      if (comps.length > tier2Max) comps = comps.slice(0, tier2Max)
      var n = comps.length
      var DRILL_IDXS = []
      ;[Math.floor(n / 3), Math.floor((2 * n) / 3)].forEach(function (p) {
        if (p >= 0 && p < n && DRILL_IDXS.indexOf(p) < 0) DRILL_IDXS.push(p)
      })

      var locR = country
        ? '<span class="cm2-loc cm2-loc-row">' +
          PIN +
          '<span>' +
          escapeHtml(country) +
          '</span></span>'
        : ''
      var parent =
        '<div class="cm2-row parent" data-nm="' +
        escapeHtml(name) +
        '"><div class="nm"><span class="cm2-chev open">' +
        CHEV +
        '</span><span class="cm2-ic">' +
        BOX +
        '</span><span class="cm2-lbl"></span></div>' +
        massCell() +
        srcCell(locR) +
        '</div>'
      var statusRow =
        '<div class="cm2-row cm2-status"><div class="nm"><span class="cm2-guide tee show"></span><span class="cm2-ic">' +
        SPARK +
        '</span><span class="cm2-status-txt">Breaking down to create a complete synthetic BOM</span></div>' +
        massCell() +
        '</div>'
      // level-1 rows, with a deeper (tier-3) layer expanded under the picked rows
      var childRows = comps
        .map(function (nm, i) {
          var html = childRow(nm, i === comps.length - 1)
          if (DRILL_IDXS.indexOf(i) >= 0) {
            html = html.replace(
              '<div class="cm2-row"',
              '<div class="cm2-row cm2-open"',
            )
            for (var c = 0; c < SUB; c++) {
              html += tier3Row(c === SUB - 1)
            }
          }
          return html
        })
        .join('')
      body.innerHTML =
        '<div class="cm2-tree"><div class="cm2-cols"><div>Product breakdown</div><div>Mass</div></div><div class="cm2-rows">' +
        parent +
        statusRow +
        childRows +
        '</div></div>'
      body.classList.add('cm2-generating')
      ;(function () {
        var t0 = body.querySelector('.cm2-tree')
        if (t0) t0.classList.add('step-mass')
      })() // breaking-down step is active → warm-tint its skeletons
      // lock the rows area to the full (phase-2) height so the modal never resizes between phases
      var rowsEl = body.querySelector('.cm2-rows')
      if (rowsEl)
        rowsEl.style.minHeight =
          (2 + comps.length + DRILL_IDXS.length * SUB) * ROW_H + 'px'
      var parentRow = body.querySelector('.cm2-row.parent')
      var parentLbl = parentRow ? parentRow.querySelector('.cm2-lbl') : null
      var parentLoc = parentRow ? parentRow.querySelector('.cm2-loc-row') : null
      if (parentRow) parentRow.classList.add('in', 'built')
      if (parentLbl) {
        parentLbl.textContent = id.name
        if (fly) parentLbl.style.opacity = '0'
      }
      if (parentLoc && locFly) parentLoc.style.opacity = '0'
      var comp = Array.prototype.slice.call(
        body.querySelectorAll(
          '.cm2-tree .cm2-row:not(.parent):not(.cm2-status)',
        ),
      )
      setStatus('Analyzing product structure…', false)
      setTabPhase(ctx, 'breakdown')

      // expand the modal and glide the name into row 1 at the SAME time (FLIP).
      ;(function startMove() {
        var isHeroInline = !!(panel && panel.closest('#cm2-panels'))
        var hero = isHeroInline ? document.getElementById('hero') : null
        var browserEl = isHeroInline
          ? document.getElementById('cm2-inline-browser')
          : null
        var EXPAND_MS = isHeroInline ? 550 : 400
        if (!fly || !parentLbl) {
          modal.classList.remove('searching')
          if (isHeroInline && hero)
            hero.setAttribute('data-hero-browser', 'expanded')
          if (parentLbl) parentLbl.style.opacity = ''
          if (parentLoc) parentLoc.style.opacity = ''
          runBuild()
          return
        }
        // measure the FINAL (expanded) positions without painting, then revert
        modal.classList.add('cm2-notrans')
        if (browserEl) browserEl.classList.add('cm2-notrans')
        if (hero) hero.setAttribute('data-hero-browser', 'expanded')
        modal.classList.remove('searching')
        var lr = document.createRange()
        lr.selectNodeContents(parentLbl)
        var lastRect = lr.getBoundingClientRect()
        var locLast = parentLoc ? parentLoc.getBoundingClientRect() : null
        if (hero) hero.removeAttribute('data-hero-browser')
        modal.classList.add('searching')
        void modal.offsetWidth
        modal.classList.remove('cm2-notrans')
        if (browserEl) browserEl.classList.remove('cm2-notrans')
        // Animate font-size 19→13 (not scale) so the clone lands as native 13px text — identical to the
        // real row label, so the hand-off doesn't "pop".
        var dx = lastRect.left - firstRect.left,
          dy = lastRect.top - firstRect.top
        var ldx =
          locFly && locLast && locFirst ? locLast.left - locFirst.left : 0
        var ldy = locFly && locLast && locFirst ? locLast.top - locFirst.top : 0
        requestAnimationFrame(function () {
          modal.classList.remove('searching')
          if (isHeroInline && hero)
            hero.setAttribute('data-hero-browser', 'expanded')
          fly.style.transition =
            'transform ' +
            EXPAND_MS +
            'ms cubic-bezier(.4,0,.2,1),font-size ' +
            EXPAND_MS +
            'ms cubic-bezier(.4,0,.2,1),letter-spacing ' +
            EXPAND_MS +
            'ms ease'
          fly.classList.add('move')
          fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px)'
          fly.style.fontSize = '13px'
          fly.style.letterSpacing = 'normal'
          if (locFly && locLast) {
            locFly.style.transition =
              'transform ' + EXPAND_MS + 'ms cubic-bezier(.4,0,.2,1)'
            locFly.classList.add('move')
            locFly.style.transform = 'translate(' + ldx + 'px,' + ldy + 'px)'
          }
        })
        var landed = false
        function settle() {
          if (landed) return
          landed = true
          if (parentLbl) parentLbl.style.opacity = ''
          if (parentLoc) parentLoc.style.opacity = ''
          if (fly) {
            fly.remove()
            fly = null
          }
          if (locFly) {
            locFly.remove()
            locFly = null
          }
          runBuild()
        }
        fly.addEventListener('transitionend', settle, { once: true })
        setTimeout(settle, EXPAND_MS + 80)
      })()

      function runBuild() {
        // The "Breaking down…" row appears once (as the first move) and PERSISTS. The rows below
        // it cascade in two passes (Phase 1 = level-1, Phase 2 = deeper level), then settle into a
        // fixed final state: skeletons frozen + "Predicting manufacturing for each step" with a
        // cycling circled step number. (finishGen() not called.)
        var statusRow = body.querySelector('.cm2-status')
        var tier2 = comp.filter(function (r) {
          return !r.classList.contains('cm2-sub')
        })
        var subs = comp.filter(function (r) {
          return r.classList.contains('cm2-sub')
        })
        var first = true,
          cyclesDone = 0
        // Breaking-down beat — slower row cascade + longer holds so the status line lingers
        var BD_STEP = 62,
          BD_PHASE_GAP = 200,
          BD_TAIL = 520,
          BD_POST = 880,
          BD_HOLD = 720
        function cycle() {
          if (!comp.length || !comp[0].isConnected || !isAlive(ctx)) return
          var lead = 0
          if (first && statusRow) {
            statusRow.classList.add('in', 'built')
            lead = 1
          } // status is the very first move, then stays (built → its mass skeleton shows)
          // Phase 1 — level-1 cascade (offset by the persistent status row on the first pass)
          tier2.forEach(function (r, k) {
            setTimeout(
              function () {
                r.classList.add('in', 'built')
              },
              (k + lead) * BD_STEP,
            )
          })
          var p1 = (tier2.length - 1 + lead) * BD_STEP + BD_TAIL
          // Phase 2 — expand the deeper level under the picked rows
          setTimeout(function () {
            subs.forEach(function (r, k) {
              setTimeout(function () {
                r.classList.add('in', 'built')
              }, k * BD_STEP)
            })
          }, p1 + BD_PHASE_GAP)
          // fire the settle-to-gray right as the tree finishes opening (no long extra hold)
          var subsLastAt = subs.length
            ? p1 + BD_PHASE_GAP + (subs.length - 1) * BD_STEP
            : (tier2.length - 1 + lead) * BD_STEP
          var treeOpenAt = subsLastAt + 340 // + last row fade-in
          setTimeout(function () {
            cyclesDone++
            if (cyclesDone >= 1) {
              finalState()
              return
            } // single pass, settle into the final state
            tier2.concat(subs).forEach(function (r) {
              r.classList.remove('in', 'built')
            }) // reset, repeat
            first = false
            setTimeout(cycle, CASCADE_GAP)
          }, treeOpenAt)
        }
        function finalState() {
          // Breaking-down cascade is complete. Instead of settling to gray and THEN starting a
          // separate manufacturing step (which read as "done → not done → new shape"), we keep the
          // warm skeletons shimmering and fold manufacturing straight into this same beat.
          tier2.concat(subs).forEach(function (r) {
            r.classList.add('in', 'built')
          })
          startManufacturing()
        }
        function startManufacturing() {
          // Manufacturing prediction — a continuation of the analysis, NOT a new shape. Component
          // skeletons keep their warm shimmer (step-mass stays on) and rows keep their height; the
          // status row just MORPHS "Breaking down…" → "Predicting manufacturing for each step"
          // (same AI shimmer + spark), then streams in the predicted steps as numbered chips.
          if (!isAlive(ctx) || !comp.length || !comp[0].isConnected) return
          setTabPhase(ctx, 'manufacturing')
          var stx = statusRow
            ? statusRow.querySelector('.cm2-status-txt')
            : null
          if (stx) {
            stx.style.transition = 'opacity .22s ease'
            stx.style.opacity = '0'
            setTimeout(function () {
              if (!isAlive(ctx)) return
              stx.textContent = 'Predicting manufacturing for each step'
              stx.style.opacity = ''
            }, 220)
          }
          // give the chip ticker room for this beat: the status row spans full width (its mass
          // skeleton hides), then returns to a normal row when everything settles before sourcing.
          if (statusRow) statusRow.classList.add('cm2-mfg-active')
          // Predicted steps: pill chips (number inside + skeleton tail) linked together.
          var STEP_COUNT = 3
          var nm = statusRow ? statusRow.querySelector('.nm') : null
          if (nm && !nm.querySelector('.cm2-mfg-steps')) {
            var box = document.createElement('span')
            box.className = 'cm2-mfg-steps'
            nm.appendChild(box)
            var chips = [],
              links = []
            for (var ci = 0; ci < STEP_COUNT; ci++) {
              if (ci > 0) {
                var lk = document.createElement('span')
                lk.className = 'cm2-mfg-link'
                box.appendChild(lk)
                links.push(lk)
              }
              var chip = document.createElement('span')
              chip.className = 'cm2-mfg-chip'
              chip.innerHTML =
                '<span class="cm2-mfg-num">' +
                String(ci + 1) +
                '</span><span class="cm2-mfg-fill"></span>'
              box.appendChild(chip)
              chips.push(chip)
            }
            var beat = 320
            chips.forEach(function (chip, i) {
              if (i > 0) {
                ;(function (lk, d) {
                  setTimeout(function () {
                    if (!isAlive(ctx) || !statusRow.isConnected) return
                    lk.classList.add('show')
                  }, d)
                })(links[i - 1], beat)
                beat += 90
              }
              ;(function (c, d) {
                setTimeout(function () {
                  if (!isAlive(ctx) || !statusRow.isConnected) return
                  c.classList.add('show')
                }, d)
              })(chip, beat)
              beat += 240
            })
          }
          // brief hold on the full prediction, then settle to gray and continue into sourcing.
          setTimeout(
            function () {
              if (!isAlive(ctx) || !statusRow || !statusRow.isConnected) return
              settleAndSource()
            },
            320 + (STEP_COUNT - 1) * 330 + 520,
          )
        }
        // Manufacturing done → everything settles to gray, status row becomes a plain gray skeleton row,
        // then immediately hand off to sourcingPhase which slides the Sourcing column in.
        function settleAndSource() {
          var SETTLE_MS = 700,
            TINT_FADE = 350
          var t0 = body.querySelector('.cm2-tree')
          if (t0) t0.classList.add('cm2-settle')
          setTimeout(function () {
            if (!isAlive(ctx)) return
            if (t0) {
              t0.classList.remove('step-mass')
              t0.classList.remove('cm2-settle')
            }
            if (statusRow) {
              statusRow.classList.remove('cm2-mfg-active')
              // drop the warm "status" spark styling so the icon settles to plain gray like every other row
              statusRow.classList.add('cm2-status-flat')
              var box = statusRow.querySelector('.cm2-mfg-steps')
              if (box) box.remove()
              // status row → plain gray skeleton row: normal cube icon + gray name skeleton + gray mass
              var sic = statusRow.querySelector('.cm2-ic')
              if (sic) sic.innerHTML = BOX
              var stx = statusRow.querySelector('.cm2-status-txt')
              if (stx) {
                stx.className = 'cm2-lbl'
                stx.innerHTML = '<span class="cm2-skel sk-name"></span>'
              }
              if (!statusRow.querySelector('.cm2-mass'))
                statusRow.insertAdjacentHTML('beforeend', massCell())
              if (!statusRow.querySelector('.cm2-src'))
                statusRow.insertAdjacentHTML(
                  'beforeend',
                  '<div class="cm2-src"></div>',
                )
              statusRow.classList.add('in', 'built')
            }
            sourcingPhase()
          }, SETTLE_MS - TINT_FADE)
        }
        function sourcingPhase() {
          if (!statusRow || !statusRow.isConnected) return
          var steps = statusRow.querySelector('.cm2-steps')
          if (steps) steps.remove()
          var mpills = statusRow.querySelector('.cm2-mfg-pills')
          if (mpills) mpills.remove()
          Array.prototype.forEach.call(
            body.querySelectorAll('.cm2-mfg-trayrow'),
            function (t) {
              if (t.parentNode) t.parentNode.removeChild(t)
            },
          )
          Array.prototype.forEach.call(
            body.querySelectorAll('.cm2-has-tray'),
            function (r) {
              r.classList.remove('cm2-has-tray')
            },
          )
          var tree = body.querySelector('.cm2-tree')
          // cascade a sourcing skeleton into the rest of the rows — repeat twice, then leave it shown.
          // order strictly top-to-bottom (DOM order) so the fill reads row by row, not tier2-then-subs.
          var srcRows = Array.prototype.slice
            .call(body.querySelectorAll('.cm2-rows .cm2-row'))
            .filter(function (r) {
              return !r.classList.contains('parent') && r !== statusRow
            })
          var srcPasses = 0
          // Smoothly animate the grid (header + every row) from its current pixel widths to a target.
          // CSS can't interpolate fr→px, so we resolve everything to px: pin current, reflow, set target.
          function morphGrid(pinFn, targetFn, dur, modal) {
            dur = dur || 750 // ms — slow enough to read as a natural slide
            var els = [body.querySelector('.cm2-cols')]
            Array.prototype.push.apply(
              els,
              Array.prototype.slice.call(
                body.querySelectorAll('.cm2-rows .cm2-row'),
              ),
            )
            els = els.filter(Boolean)
            function contentW(el) {
              var cs = getComputedStyle(el)
              return (
                el.clientWidth -
                parseFloat(cs.paddingLeft) -
                parseFloat(cs.paddingRight)
              )
            }
            // Browsers don't reliably transition grid-template-columns (it snaps), so we interpolate it by hand.
            var plan = els.map(function (el) {
              var w = contentW(el)
              var start = pinFn
                ? pinFn(w)
                : getComputedStyle(el)
                    .gridTemplateColumns.split(' ')
                    .map(parseFloat)
              var end = targetFn(w)
              while (start.length < end.length) start.push(0)
              while (end.length < start.length) end.push(0)
              el.style.transition = 'none' // we drive it frame-by-frame, no CSS transition
              return { el: el, start: start, end: end }
            })
            function set(it, e) {
              it.el.style.gridTemplateColumns = it.start
                .map(function (s, i) {
                  return Math.max(0, Math.round(s + (it.end[i] - s) * e)) + 'px'
                })
                .join(' ')
            }
            // optional: grow the modal itself to fit the columns, so a new column appears in fresh space
            // instead of shoving the others left. Modal width = grid content + row padding(30) + body padding(40).
            var maxW = document.documentElement.clientWidth * 0.96
            function modalWForE(e) {
              var c = plan[0],
                sum = 0
              for (var i = 0; i < c.start.length; i++)
                sum += c.start[i] + (c.end[i] - c.start[i]) * e
              return Math.min(maxW, sum + (c.start.length - 1) * 10 + 70)
            }
            if (modal) modal.style.transition = 'none'
            plan.forEach(function (it) {
              set(it, 0)
            })
            if (modal) modal.style.width = Math.round(modalWForE(0)) + 'px'
            void body.offsetWidth
            function ease(p) {
              return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2
            } // easeInOutQuad — gentle in/out
            var t0 = null
            function frame(ts) {
              if (t0 === null) t0 = ts
              var p = Math.min(1, (ts - t0) / dur),
                e = ease(p)
              plan.forEach(function (it) {
                set(it, e)
              })
              if (modal) modal.style.width = Math.round(modalWForE(e)) + 'px'
              if (p < 1) requestAnimationFrame(frame)
              else {
                plan.forEach(function (it) {
                  it.el.style.transition = ''
                })
                if (modal) modal.style.transition = ''
              }
            }
            requestAnimationFrame(frame)
          }
          function srcCascade() {
            if (!statusRow.isConnected || !isAlive(ctx)) return
            srcRows.forEach(function (r, k) {
              setTimeout(function () {
                var sc = r.querySelector('.cm2-src')
                if (sc && !sc.querySelector('.cm2-skel'))
                  sc.innerHTML = '<span class="cm2-skel sk-num"></span>'
              }, k * CASCADE_STEP)
            })
            var done = (srcRows.length - 1) * CASCADE_STEP + 650
            setTimeout(function () {
              srcPasses++
              if (srcPasses >= 1) {
                setTimeout(layerIntel, CASCADE_GAP)
                return
              } // one pass → layer intelligence (cost)
              srcRows.forEach(function (r) {
                var sc = r.querySelector('.cm2-src')
                if (sc) sc.innerHTML = ''
              })
              setTimeout(srcCascade, CASCADE_GAP)
            }, done + CASCADE_HOLD)
          }
          // Cost step — mirrors sourcing: CLOSE the sourcing column (mass slides back), then SLIDE the
          // Cost column in from the right. "Layering intelligence" appears as it opens; a beat later the
          // cost skeletons cascade top-to-bottom. (Reuses the single 3rd-column slot; revealFinal rebuilds
          // the real model with all columns anyway.)
          function layerIntel() {
            if (!statusRow.isConnected || !isAlive(ctx)) return
            setTabPhase(ctx, 'costing')
            var CLOSE_DUR = 380,
              OPEN_DUR = 560
            if (tree) tree.classList.remove('gap-src')
            // 1) BEFORE collapsing, wipe the sourcing column clean (header text + every cell's pill/globe/
            //    skeleton) so nothing peeks past the shrinking column edge as it closes.
            var header = body.querySelector('.cm2-cols')
            if (header && header.children[2])
              header.children[2].textContent = ''
            body
              .querySelectorAll('.cm2-rows .cm2-row .cm2-src')
              .forEach(function (sc) {
                sc.innerHTML = ''
              })
            // now collapse the 3rd column 150→0 (mass eases back to the right)
            morphGrid(
              function (w) {
                return [w - 96 - 150 - 20, 96, 150]
              },
              function (w) {
                return [w - 96 - 20, 96, 0]
              },
              CLOSE_DUR,
            )
            // wait until the column is FULLY collapsed (+buffer) before opening Cost
            setTimeout(function () {
              if (!statusRow.isConnected || !isAlive(ctx)) return
              if (header && header.children[2])
                header.children[2].textContent = 'Cost'
              // 2) open the Cost column from the right (mass eases left again)
              if (tree) tree.classList.add('gap-src') // warm tint on the active 3rd column
              morphGrid(
                function (w) {
                  return [w - 96 - 20, 96, 0]
                },
                function (w) {
                  return [w - 96 - 150 - 20, 96, 150]
                },
                OPEN_DUR,
              )
              // "Layering intelligence" appears AS the column opens (parent row's 3rd cell)
              var parentRow = body.querySelector('.cm2-row.parent')
              if (parentRow) {
                var pc = parentRow.querySelector('.cm2-src')
                if (pc)
                  pc.innerHTML =
                    '<span class="cm2-src-txt">Layering intelligence</span>'
              }
              // 3) hold a beat after the column lands, then cascade the cost skeletons top-to-bottom
              setTimeout(function () {
                if (!statusRow.isConnected || !isAlive(ctx)) return
                // DOM order (status row sits right under the parent) so the cascade reads strictly
                // top-to-bottom — the first skeleton below "Layering intelligence" appears first.
                var costRows = Array.prototype.slice
                  .call(body.querySelectorAll('.cm2-rows .cm2-row'))
                  .filter(function (r) {
                    return !r.classList.contains('parent')
                  })
                var costPasses = 0
                function costCascade() {
                  if (!isAlive(ctx)) return
                  costRows.forEach(function (r, k) {
                    setTimeout(function () {
                      var c = r.querySelector('.cm2-src')
                      if (c && !c.querySelector('.cm2-skel'))
                        c.innerHTML = '<span class="cm2-skel sk-num"></span>'
                    }, k * CASCADE_STEP)
                  })
                  var done = (costRows.length - 1) * CASCADE_STEP + 650
                  setTimeout(function () {
                    costPasses++
                    if (costPasses >= 1) {
                      revealFinal()
                      setTabPhase(ctx, 'ready')
                      return
                    } // one pass → reveal the real model
                    costRows.forEach(function (r) {
                      var c = r.querySelector('.cm2-src')
                      if (c) c.innerHTML = ''
                    })
                    setTimeout(costCascade, CASCADE_GAP)
                  }, done + CASCADE_HOLD)
                }
                costCascade()
              }, OPEN_DUR + 260)
            }, CLOSE_DUR + 180)
          }
          // Final state — reveal the real model directly, then raise the email gate. Mirrors the modal's
          // revealFinal: collapse the status row, resolve the skeleton names, fill mass & cost with real
          // values + proportional bars (first level + product only), all behind a quick cm2-swap fade.
          function revealFinal() {
            if (!isAlive(ctx)) return
            if (window.heroUseSampleReveal) {
              var tree = body.querySelector('.cm2-tree')
              var rowsBox = tree && tree.querySelector('.cm2-rows')
              if (rowsBox) rowsBox.classList.add('cm2-swap')
              setTimeout(function () {
                if (!isAlive(ctx)) return
                var sampleKey = window.heroPendingSampleKey || 'nmc'
                ctx.panel.hidden = true
                ctx.panel.classList.remove('is-active')
                setSampleVisible(true)
                function finishHeroReveal() {
                  if (window.heroShowSample) window.heroShowSample(sampleKey)
                  if (window.finalizeHeroGeneratedTab)
                    window.finalizeHeroGeneratedTab(ctx, sampleKey)
                  var hero = document.getElementById('hero')
                  if (hero) hero.setAttribute('data-hero-phase', 'ready')
                  window.heroUseSampleReveal = false
                  if (window.scheduleHeroTabCta) window.scheduleHeroTabCta()
                  var genBtn = document.getElementById('hero-generate-btn')
                  if (genBtn) {
                    genBtn.disabled = false
                    genBtn.textContent = 'Generate Cost Model'
                  }
                }
                if (window.heroPanelsReady && window.heroShowSample)
                  finishHeroReveal()
                else if (window.heroGenerateSample)
                  window.heroGenerateSample(sampleKey).then(finishHeroReveal)
                else finishHeroReveal()
              }, 240)
              return
            }
            var tree = body.querySelector('.cm2-tree')
            var rowsBox = tree && tree.querySelector('.cm2-rows')
            if (!rowsBox) return
            // 1) fade the skeleton rows out quickly (no shimmer overlay)
            rowsBox.classList.add('cm2-swap')
            // 2) while hidden, swap EVERYTHING to the final output INLINE in one shot — collapse the
            //    status/sub rows, resolve names, fill real data. The email gate lives in the LEFT hero
            //    form (not a floating panel), so here we only blur the Cost column until it's submitted.
            setTimeout(function () {
              if (!isAlive(ctx)) {
                rowsBox.classList.remove('cm2-swap')
                return
              }
              var sr = body.querySelector('.cm2-status')
              if (sr) sr.remove()
              body.querySelectorAll('.cm2-row[data-nm]').forEach(resolveName)
              revealRealData(body) // drop sub rows, snap grid, fill real values + product totals
              /* email gate disabled in landing demo */
              // 3) reveal: final output fades back in
              requestAnimationFrame(function () {
                rowsBox.classList.remove('cm2-swap')
              })
            }, 240)
          }
          // Sourcing column SLIDES in from the right (mass eases left). China pill + "Predicting sourcing"
          // fade in AS the column opens; the warm cascade skeletons wait a beat, then run top-to-bottom.
          if (!statusRow.isConnected || !isAlive(ctx)) return
          var header = body.querySelector('.cm2-cols')
          if (header && header.children.length < 3) {
            var sh = document.createElement('div')
            sh.textContent = 'Sourcing'
            header.appendChild(sh)
          }
          if (tree) tree.classList.add('cm2-srccol', 'gap-src')
          var SRC_DUR = 620
          morphGrid(
            function (w) {
              return [w - 96 - 20, 96, 0]
            },
            function (w) {
              return [w - 96 - 150 - 20, 96, 150]
            },
            SRC_DUR,
          )
          // parent's country pill + status row's sourcing label appear together with the opening column
          var parentRow = body.querySelector('.cm2-row.parent')
          var pill = parentRow ? parentRow.querySelector('.cm2-loc-row') : null
          if (pill) {
            pill.style.opacity = ''
            pill.classList.add('cm2-loc-in')
          }
          var ssrc = statusRow.querySelector('.cm2-src')
          if (ssrc)
            ssrc.innerHTML =
              '<svg class="cm2-src-ic" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"/><path d="M3.6 9h16.8"/><path d="M3.6 15h16.8"/><path d="M11.5 3a17 17 0 0 0 0 18"/><path d="M12.5 3a17 17 0 0 1 0 18"/></svg><span class="cm2-src-txt">Predicting sourcing</span>'
          // hold a beat after the column lands, THEN cascade the warm src skeletons
          setTimeout(function () {
            if (!statusRow.isConnected || !isAlive(ctx)) return
            srcCascade()
          }, SRC_DUR + 260)
        }
        cycle()
      }

      function finishGen() {
        comp.forEach(function (x) {
          x.classList.remove('active')
        })
        var sr = body.querySelector('.cm2-status')
        if (sr) {
          sr.classList.add('gone')
          setTimeout(function () {
            sr.remove()
          }, 320)
        }
        body.classList.remove('cm2-generating')
        body
          .querySelectorAll('.cm2-row[data-nm]:not(.parent)')
          .forEach(resolveName)
        setStatus(
          'Structure ready · ' + comps.length + ' components mapped',
          true,
        )
      }
    }
  }

  // Replace the gated skeletons with the real (synthetic) cost model: first-level rows only, all columns filled.
  function revealRealData(body) {
    var rowsBox = body.querySelector('.cm2-rows')
    if (!rowsBox) return
    rowsBox.classList.remove('cm2-gated') // un-blur
    rowsBox
      .querySelectorAll('.cm2-row.cm2-sub, .cm2-row.cm2-status')
      .forEach(function (r) {
        r.remove()
      }) // first level only
    var SRC_COUNTRIES = [
      'China',
      'Vietnam',
      'Mexico',
      'Taiwan',
      'India',
      'Germany',
    ]
    var rows = Array.prototype.slice.call(rowsBox.querySelectorAll('.cm2-row'))
    function massTxt(g) {
      return g >= 1000 ? (g / 1000).toFixed(2) + ' kg' : g + ' g'
    }
    var totalMass = 0,
      totalCost = 0,
      leaves = []
    rows.forEach(function (r, i) {
      if (r.classList.contains('parent')) return
      var m = 8 + ((i * 53 + 17) % 92),
        c = m * 0.9 + ((i * 29 + 13) % 48) // deterministic, plausible
      leaves.push({ r: r, m: m, c: c, i: i })
      totalMass += m
      totalCost += c
    })
    leaves.forEach(function (v) {
      var mass = v.r.querySelector('.cm2-mass')
      if (mass)
        mass.innerHTML = '<span class="cm2-val">' + massTxt(v.m) + '</span>'
      var cost = v.r.querySelector('.cm2-cost')
      if (cost) cost.innerHTML = '<span class="cm2-val">' + fmt(v.c) + '</span>'
      var src = v.r.querySelector('.cm2-src')
      if (src)
        src.innerHTML =
          '<span class="cm2-loc">' +
          PIN +
          '<span>' +
          SRC_COUNTRIES[v.i % SRC_COUNTRIES.length] +
          '</span></span>'
    })
    var p = rowsBox.querySelector('.cm2-row.parent')
    if (p) {
      var pm = p.querySelector('.cm2-mass')
      if (pm)
        pm.innerHTML =
          '<span class="cm2-val" style="font-weight:600">' +
          massTxt(totalMass) +
          '</span>'
      var pc = p.querySelector('.cm2-cost')
      if (pc)
        pc.innerHTML =
          '<span class="cm2-val" style="font-weight:600">' +
          fmt(totalCost) +
          '</span>'
    }
  }

  // The most important CTA — "Model your own product" — surfaced INSIDE the result window as a
  // sticky bar that slides in once the sample model settles. Clicking it expands an inline email
  // capture (reusing the work-email validation), then confirms the model is on the way.
  var CHECK_SVG =
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'
  function mountCtaBar(ctx) {
    if (!isAlive(ctx)) return
    if (ctx.panel.querySelector('.cm2-cta-bar')) return // once per tab
    var bar = document.createElement('div')
    bar.className = 'cm2-cta-bar'
    bar.innerHTML =
      '<div class="cm2-cta-bar__msg">Built in ~12s — this is a <b>sample</b> model.</div>' +
      '<div class="cm2-cta-bar__action">' +
      '<button type="button" class="cm2-cta-bar__btn" data-cta-open>Model your own product &rarr;</button>' +
      '<div class="cm2-cta-form" hidden>' +
      '<input type="email" placeholder="you@company.com" autocomplete="email"/>' +
      '<button type="button" class="cm2-cta-bar__btn" data-cta-send>Email me the model</button>' +
      '<a class="cm2-cta-bar__demo" href="https://calendly.com/harris-muir/muir-demo-request" target="_blank" rel="noopener">Book a demo</a>' +
      '<div class="cm2-cta-bar__err">Please enter a valid work email.</div>' +
      '</div>' +
      '<div class="cm2-cta-bar__sent" hidden></div>' +
      '</div>'
    ctx.panel.appendChild(bar)
    var openBtn = bar.querySelector('[data-cta-open]')
    var form = bar.querySelector('.cm2-cta-form')
    var input = bar.querySelector('input')
    var sendBtn = bar.querySelector('[data-cta-send]')
    var err = bar.querySelector('.cm2-cta-bar__err')
    var sent = bar.querySelector('.cm2-cta-bar__sent')
    openBtn.addEventListener('click', function () {
      bar.classList.add('is-form')
      openBtn.hidden = true
      form.hidden = false
      input.focus()
    })
    function submit() {
      var v = (input.value || '').trim(),
        lv = v.toLowerCase(),
        at = lv.indexOf('@')
      var ok =
        at > 0 &&
        lv.indexOf('.', at) > at &&
        PERSONAL.indexOf(lv.slice(at + 1)) < 0
      if (!ok) {
        input.classList.add('err')
        err.classList.add('on')
        input.focus()
        return
      }
      ctx.email = v
      if (window.MuirLead)
        window.MuirLead({
          email: v,
          product:
            (document.getElementById('hero-dd-product') || {}).value || '',
          country:
            (document.getElementById('hero-dd-country') || {}).value || '',
          source: 'cm2-cta',
        })
      form.hidden = true
      err.classList.remove('on')
      sent.innerHTML =
        CHECK_SVG +
        '<span>Your cost model is on the way to ' +
        escapeHtml(v) +
        '</span>'
      sent.hidden = false
    }
    sendBtn.addEventListener('click', submit)
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submit()
    })
    input.addEventListener('input', function () {
      input.classList.remove('err')
      err.classList.remove('on')
    })
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.classList.add('in')
      })
    })
  }

  // Each "Build Cost Model" opens a new browser tab in the inline hero window.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('#build-cost-model')
      if (!btn) return
      var nameEl = document.getElementById('product-name')
      var sel = document.getElementById('country')
      var name = nameEl ? nameEl.value.trim() : ''
      var country =
        sel && sel.selectedIndex >= 0
          ? (sel.options[sel.selectedIndex].text || '').trim()
          : ''
      if (!name || !country) return // let existing validation handle empties
      e.preventDefault()
      e.stopImmediatePropagation()
      createTab(name, country)
    },
    true,
  )
  window.cm2BuildTab = createTab
  initBrowser()
  initHeroPanel()
}
